import React from 'react';
import cs from 'classnames';
import { translate } from '@shakkerai/util-i18n';

import styles from './index.module.scss';
const DivideLine = React.memo(() => {
  return (
    <div className="flex h-[18px] justify-center items-center">
      <i className={cs('block w-[145px] h-[1px]', styles.line)} />
      <h5 className={cs('mx-3', styles.text)}>{translate('modelhub_button_Community')}</h5>
      <i className={cs('block w-[145px] h-[1px]', styles.line)} />
    </div>
  );
});

export default DivideLine;
